<template>
  <remotescript src="https://g.alicdn.com/dingding/dingtalk-jsapi/2.6.41/dingtalk.open.js" @load="load"></remotescript>
</template>

<script>
import { Loading } from 'element-ui'
// import 'https://g.alicdn.com/dingding/dingtalk-jsapi/2.6.41/dingtalk.open.js'
export default {
  name: 'dingtalklogin',
  data () {
    return {
      corpId: '',
      code: ''
    }
  },
  methods: {
    load() {
      try {
        window.dd.ready(function() {
          window.dd.runtime.permission.requestAuthCode({
            corpId: 'dingfa7e1c7c9755ad8e', // 企业id
            onSuccess: function (info) {
              // this.code = info.code // 通过该免登授权码可以获取用户身份
              // alert('api/DingTalk/Login?Code=' + info.code)
              location.href = 'api/DingTalk/Login?Code=' + info.code
            },
            onFail: function (err) {
              alert('Fail' + err)
            }
          })
        })

        window.dd.error(function(error) {
          alert('dd error: ' + JSON.stringify(error))
        })
      } catch (err) {
        alert(err)
      }
    }
  },
  mounted() {
    Loading.service({ fullscreen: true })
  }
}
</script>